/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { useLayoutEffect, withMemo, useState } from 'fierry/react.old';


export default withMemo( ({ canDispatch, executeDispatch, ...props }) =>
{
  const [previousDispatch, setPreviousDispatch] = useState(false);

  useLayoutEffect(() =>
  {
    const currentDispatch = canDispatch(props);

    if (!previousDispatch && currentDispatch)
    {
      executeDispatch(props);
    }

    setPreviousDispatch(currentDispatch);
  });

  return null;
});
